// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
// You can define here the tab components mapping for the custom parameters group of your solution
import DataVector from '../../../components/DataVector/DataVector';
import EquipementWizard from '../../../components/EquipementsWizard/EquipementWizard';
import WizardAndGantt from '../../../components/TechnicalPolicyWizard/GanttWizardContainer';

export const CUSTOM_PARAMETERS_GROUPS_COMPONENTS_MAPPING = {
  aging_law_parameters: EquipementWizard,
  // parametersGroupId: CustomScenarioParametersTabComponent,
  technical_policy_parameters: WizardAndGantt,
  data_vector_parameters: DataVector,
};
